import React from 'react';
import { motion } from 'framer-motion';

const PageHero = ({ eyebrow, title, highlight, description, children }) => {
  return (
    <section className="py-20 relative bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          {eyebrow && (
            <div className="inline-flex items-center space-x-2 bg-[#398024]/5 border border-[#398024]/20 rounded-full px-6 py-2 mb-6">
              <span className="w-2 h-2 bg-[#398024] rounded-full" />
              <span className="text-[#398024] text-sm font-semibold">{eyebrow}</span>
            </div>
          )}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6">
            {title}
            {highlight && (
              <>
                <br />
                <span className="text-[#398024]">{highlight}</span>
              </>
            )}
          </h1>
          {description && (
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              {description}
            </p>
          )}
        </motion.div>
        {children}
      </div>
    </section>
  );
};

export default PageHero;
